// extracted by mini-css-extract-plugin
var _1 = "Cqyxx fieldset-reset";
var _2 = "KVH96";
var _3 = "GEtyQ";
var _4 = "uyJoD";
export { _1 as "base", _2 as "days", _3 as "theme-dark", _4 as "theme-light" }
